// Use this if you want to force 2 decimal places
export const TWO_DECIMAL_DIGITS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export function formatDollars(
  amount?: number | string,
  options: Intl.NumberFormatOptions = {}
): string {
  if (amount === undefined) {
    return '';
  }

  if (typeof amount === 'string') {
    const str = amount.trim();
    if (str.startsWith('-')) {
      return `-$${str.slice(1)}`;
    }
    return `$${str}`;
  }

  // While numbers can skip the decimals, everything else cant
  const isWhole = Number.isFinite(amount) && Number(amount) % 1 === 0;
  const formatOptions = isWhole
    ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    : { minimumFractionDigits: 2, maximumFractionDigits: 2 };

  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    useGrouping: false,
    ...formatOptions,
    ...options,
  }).format(amount);
}

export function formatNumber(num: number, options: Intl.NumberFormatOptions = {}): string {
  return Intl.NumberFormat('en-US', {
    style: 'decimal',
    ...options,
  }).format(num);
}
